import React from "react";
import ReactDOM from "react-dom";
import Helmet from "react-helmet";
import { useLocalize } from "shared/helpers/language";

import "react-phone-input-2/lib/style.css"
import "react-toastify/dist/ReactToastify.min.css"
import "devextreme/dist/css/dx.material.blue.light.compact.css";
import "shared/assets/styles/devextremThem/dxmaterialcustom.css";
import "shared/assets/styles/main.scss";

const LTR = () => <link type="text/css" rel="stylesheet" href="/css/bootstrap.min.css" />;
const RTL = () => <link type="text/css" rel="stylesheet" href="/css/bootstrap.rtl.min.css" />;
const BootStrapStyles = ({ language }: any) => ReactDOM.createPortal(language?.dir === "rtl" ? <RTL /> : <LTR />, document.head);

export default function Styles() {
  const { currentLanguage } = useLocalize();

  return (
    <>
      <Helmet
        htmlAttributes={{
          dir: currentLanguage?.dir,
          lang: currentLanguage?.code,
        }}
      />
      <BootStrapStyles language={currentLanguage} />
    </>
  );
}
